import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ReplaceLineBreaksPipe } from '../../pages/theme/replace-line-breaks/replace-line-breaks';

@Component({
  selector: 'app-note-editor',
  standalone: true,
  imports: [CommonModule, ReplaceLineBreaksPipe],
  templateUrl: './note-editor.component.html',
  styleUrls: ['./note-editor.component.scss']
})
export class NoteEditorComponent implements OnChanges {
  private static nextId = 0;
  readonly inputId = `ia-note-${NoteEditorComponent.nextId++}`;
  @Input() title = 'Notes';
  @Input() value: string | null | undefined;
  @Input() editing = false;
  @Output() editingChange = new EventEmitter<boolean>();
  @Output() saved = new EventEmitter<string>();
  draft = '';
  private restoreFocus = false;

  @ViewChild('noteInput') set noteInput(input: ElementRef<HTMLTextAreaElement> | undefined) {
    input?.nativeElement.focus();
  }

  @ViewChild('editButton') set editButton(button: ElementRef<HTMLButtonElement> | undefined) {
    if (button && this.restoreFocus) {
      button.nativeElement.focus();
      this.restoreFocus = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.editing?.currentValue) this.draft = this.value || '';
  }

  startEdit(): void {
    this.draft = this.value || '';
    this.editing = true;
    this.editingChange.emit(true);
  }

  updateDraft(event: Event): void {
    this.draft = (event.target as HTMLTextAreaElement).value;
  }

  cancel(): void {
    this.draft = this.value || '';
    this.finishEdit();
  }

  save(): void {
    if (!this.editing) return;
    const value = this.draft;
    this.finishEdit();
    this.saved.emit(value);
  }

  private finishEdit(): void {
    this.restoreFocus = true;
    this.editing = false;
    this.editingChange.emit(false);
  }
}
